import { useEffect } from "react";
import SEO from "./pages.json";

export { SEO };

const meta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Keeps the tab title, description, canonical link and share tags in step with the marketing page shown.
export const useSeo = (path) => {
  useEffect(() => {
    const p = SEO.pages[path];
    const url = SEO.site.url + path;
    document.title = p.title;
    meta("name", "description", p.description);
    meta("property", "og:title", p.title);
    meta("property", "og:description", p.description);
    meta("property", "og:url", url);
    meta("name", "twitter:title", p.title);
    meta("name", "twitter:description", p.description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [path]);
};
